// src/components/home/Services/ServicesItem/ServicesItem.jsx
import React from 'react';
import style from './ServicesItem.module.css';
import { useParams } from 'react-router-dom';
import { normalizeLang } from '../../../../helpers/translation'; // ⬅️ 4 рівні вгору

const ServicesItem = ({ data, contactLabel }) => {
  const { lang: raw } = useParams();
  const langCode = normalizeLang(raw); // 'en' якщо немає префікса

  const title = data?.title || '';
  const descriptionList = Array.isArray(data?.descriptionList)
    ? data.descriptionList
    : [];

  return (
    <div className={style.gradientContainer}>
      <div className={style.servicesItem}>
        {/* lang для коректної гіпенізації (hyphens:auto) */}
        <h1 lang={langCode}>{title}</h1>

        <div className={style.descriptionContainer}>
          {descriptionList.map((item, i) => (
            <p key={i} lang={langCode}>
              {item}
            </p>
          ))}
        </div>

        <a href="#contact">
          <button className={style.contactUs}>{contactLabel}</button>
        </a>
      </div>
    </div>
  );
};

export default ServicesItem;
